import { render, staticRenderFns } from "./ProductResponsiveCard.vue?vue&type=template&id=5e41f3cd"
import script from "./ProductResponsiveCard.vue?vue&type=script&lang=js"
export * from "./ProductResponsiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports